export const evidences = [
  {
    id: "6gzhbamall3xfe2gzdmlnw9aj",
    category: "publications",
    created_at: "Thu May 17 2018 03:00:00 GMT+0300 (Israel Daylight Time)", // 17/May/2018
    user: {
      user_id: "dsfafdasfdas",
      name: "Taly Yafe",
      pic_url: ""
    },
    source: "http://en.Wikipedia/wiki/DNA",
    description:
      "The DNA double helix is stabilized primarily by two forces: " +
      "hydrogen bonds between nucleotides and base-stacking interactions among aromatic nucleobases. " +
      "In the cytosol of the cell,\n" +
      "the conjugated pi bonds of nucleotide bases align perpendicular to the axis of the DNA molecule," +
      " minimizing their interaction with the solvation shell.",
    level: "A1",
    zygosity_type: "somatic"
  },
  {
    id: "7gzhbamall3xfe2gzdmlnw9aj",
    category: "publications",
    created_at: "Sun Jun 17 2018 03:00:00 GMT+0300 (Israel Daylight Time)",
    user: {
      user_id: "qwqmmbnvb",
      name: "Lior GoldBerg",
      pic_url: ""
    },
    source: "http://en.Wikipedia/wiki/GSID-Genom",
    level: "A2",
    zygosity_type: "somatic"
  },
  {
    id: "61zhbamall3xfe2gzdmlnw9aj",
    category: "publications",
    created_at: "Mon Sep 03 2018 03:00:00 GMT+0300 (Israel Daylight Time)",
    user: {
      user_id: "dsfafdasfdas",
      name: "Taly Yafe",
      pic_url: ""
    },
    source: "http://en.Wikipedia/wiki/DNA",
    description:
      "The DNA double helix is stabilized primarily by two forces: " +
      "hydrogen bonds between nucleotides and base-stacking interactions among aromatic nucleobases. " +
      "In the cytosol of the cell,\n" +
      "the conjugated pi bonds of nucleotide bases align perpendicular to the axis of the DNA molecule," +
      " minimizing their interaction with the solvation shell.",
    level: "C1",
    zygosity_type: "somatic"
  },
  {
    id: "71zhbamall3xfe2gzdmlnw9aj",
    category: "publications",
    created_at: "Sat Mar 31 2018 03:00:00 GMT+0300 (Israel Daylight Time)",
    user: {
      user_id: "qwqmmbnvb",
      name: "Lior GoldBerg",
      pic_url: ""
    },
    source: "http://en.Wikipedia/wiki/GSID-Genom",
    description:
      "The DNA double helix is stabilized primarily by two forces: " +
      "hydrogen and base-stacking interactions.",
    level: "none",
    zygosity_type: "somatic"
  },
  {
    id: "8gzhbamall3xfe2gzdmlnw9aj",
    category: "frequency",
    created_at: "Fri Feb 23 2018 02:00:00 GMT+0200 (Israel Standard Time)",
    user: {
      user_id: "dsfafdasfdas",
      name: "Taly Yafe",
      pic_url: ""
    },
    source: "http://en.Wikipedia/wiki/RNA-GSID-Genom",
    description:
      "The RNA double helix is stabilized primarily by two forces: " +
      "hydrogen bonds between nucleotides and base-stacking interactions among aromatic nucleobases. " +
      "In the cytosol of the cell,\n" +
      "the conjugated pi bonds of nucleotide bases align perpendicular to the axis of the RNA molecule",
    level: "B",
    zygosity_type: "somatic"
  },
  {
    id: "9gzhbamall3xfe2gzdmlnw9aj",
    category: "other",
    created_at: "Fri Apr 13 2018 03:00:00 GMT+0300 (Israel Daylight Time)",
    user: {
      user_id: "dsfafdasfdas",
      name: "Taly Yafe",
      pic_url: ""
    },
    source: "http://en.Wikipedia/wiki/DNA",
    description:
      "The DNA double helix is stabilized primarily by two forces: " +
      "hydrogen bonds between nucleotides and base-stacking interactions among aromatic nucleobases. " +
      "In the cytosol of the cell,\n" +
      "the conjugated pi bonds of nucleotide bases align perpendicular to the axis of the DNA molecule," +
      " minimizing their interaction with the solvation shell.",
    level: "C1",
    zygosity_type: "somatic"
  },
  {
    id: "10zhbamall3xfe2gzdmlnw9aj",
    category: "other",
    created_at: "Fri Jun 01 2018 03:00:00 GMT+0300 (Israel Daylight Time)",

    user: {
      user_id: "qwqmmbnvb",
      name: "Lior GoldBerg",
      pic_url: ""
    },
    source: "http://en.Wikipedia/wiki/GSID-Genom",
    description:
      "The DNA double helix is stabilized primarily by two forces: " +
      "hydrogen and base-stacking interactions.",

    level: "D",
    zygosity_type: "somatic"
  },
  {
    id: "1gzhbamall3xfe2gzdmlnw9aj",
    category: "publications",
    created_at: "Sun Jun 17 2018 03:00:00 GMT+0300 (Israel Daylight Time)",
    user: {
      user_id: "dsfafdasfdas",
      name: "Taly Yafe",
      pic_url: ""
    },
    source: "http://en.Wikipedia/wiki/DNA",
    description:
      "The DNA double helix is stabilized primarily by two forces: " +
      "hydrogen bonds between nucleotides and base-stacking interactions among aromatic nucleobases. " +
      "In the cytosol of the cell,\n" +
      "the conjugated pi bonds of nucleotide bases align perpendicular to the axis of the DNA molecule," +
      " minimizing their interaction with the solvation shell.",
    level: "PVS1",
    zygosity_type: "germline"
  },
  {
    id: "2gzhbamall3xfe2gzdmlnw9aj",
    category: "publications",
    created_at: "Thu May 17 2018 03:00:00 GMT+0300 (Israel Daylight Time)",
    user: {
      user_id: "qwqmmbnvb",
      name: "Lior GoldBerg",
      pic_url: ""
    },
    source: "http://en.Wikipedia/wiki/GSID-Genom",
    description:
      "The DNA double helix is stabilized primarily by two forces: " +
      "hydrogen and base-stacking interactions.",
    level: "PM1",
    zygosity_type: "germline"
  },
  {
    id: "3gzhbamall3xfe2gzdmlnw9aj",
    category: "frequency",
    created_at: "Mon Sep 03 2018 03:00:00 GMT+0300 (Israel Daylight Time)",
    user: {
      user_id: "dsfafdasfdas",
      name: "Taly Yafe",
      pic_url: ""
    },
    source: "http://en.Wikipedia/wiki/RNA-GSID-Genom",
    description:
      "The RNA double helix is stabilized primarily by two forces: " +
      "hydrogen bonds between nucleotides and base-stacking interactions among aromatic nucleobases. " +
      "In the cytosol of the cell,\n" +
      "the conjugated pi bonds of nucleotide bases align perpendicular to the axis of the RNA molecule",
    level: "PP1",
    zygosity_type: "germline"
  },
  {
    id: "4gzhbamall3xfe2gzdmlnw9aj",
    category: "variantDB",
    created_at: "Fri Feb 23 2018 02:00:00 GMT+0200 (Israel Standard Time)",
    user: {
      user_id: "dsfafdasfdas",
      name: "Taly Yafe",
      pic_url: ""
    },
    source: "http://en.Wikipedia/wiki/DNA",
    description:
      "The DNA double helix is stabilized primarily by two forces: " +
      "hydrogen bonds between nucleotides and base-stacking interactions among aromatic nucleobases. " +
      "In the cytosol of the cell,\n" +
      "the conjugated pi bonds of nucleotide bases align perpendicular to the axis of the DNA molecule," +
      " minimizing their interaction with the solvation shell.",
    level: "BP6",
    zygosity_type: "germline"
  },
  {
    id: "5gzhbamall3xfe2gzdmlnw9aj",
    category: "variantDB",
    created_at: "Fri Jun 01 2018 03:00:00 GMT+0300 (Israel Daylight Time)",

    user: {
      user_id: "qwqmmbnvb",
      name: "Lior GoldBerg",
      pic_url: ""
    },
    source: "http://en.Wikipedia/wiki/GSID-Genom",
    description:
      "The DNA double helix is stabilized primarily by two forces: " +
      "hydrogen and base-stacking interactions.",

    level: "BS4",
    zygosity_type: "germline"
  }
];
